import React from 'react';
import PropTypes from 'prop-types';
import SkeletonScreen from './SkeletonScreen';
import CommonPreviewComponent from './CommonPreviewComponent';
import getLocaleMessages from '../../utils/localesMessages';
const messages = getLocaleMessages('buttonsV3/buttonPreview');

const ButtonFactoryV3SdkPreview = ({
  isButtonOverviewPreview = false,
  isGuestPagePreview = false,
}) => {
  return (
    <div className="popup-container">
      <SkeletonScreen isGuestPagePreview={isGuestPagePreview} />
      <div className="popup-window">
        <div className="title-bar" aria-hidden="true">
          <div className="buttons">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div
          className="popup-window-content"
          role="region"
          aria-label={messages.navigator.popUp.popUpAccessibility}
        >
          <CommonPreviewComponent
            isButtonOverviewPreview={isButtonOverviewPreview}
            isSDKPreview={true}
          />
        </div>
      </div>
    </div>
  );
};

ButtonFactoryV3SdkPreview.propTypes = {
  isButtonOverviewPreview: PropTypes.bool,
  isGuestPagePreview: PropTypes.bool,
};
export default ButtonFactoryV3SdkPreview;
